module.exports = __webpack_public_path__ + "img/EmptyState.2977473b.svg";